/**
 * mSTEM SmartHome dashboard modal container (Phase 5 / SMH-02, DR-04).
 *
 * CLASS container (NOT the stateless compose pattern) because it owns the
 * 2s `setInterval` lifecycle + the local sensor series. On mount it seeds
 * the series/RFID-logs/alerts from the mock generator and starts the tick;
 * each tick appends a random-walk point and caps the series at 20; on
 * unmount it `clearInterval`s (null-guarded) so there is no
 * setState-after-unmount leak (RESEARCH Pattern 4 / Pitfall 2). The modal
 * is conditionally mounted in gui.jsx, so close → unmount → clear.
 *
 * React-16 class + lodash.bindall — NO hooks, NO class-field arrows.
 */
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {closeSmartHomeDashboard} from '../reducers/modals';
import {getInitialSeries, getRfidLogs, getAlerts, nextPoint} from '../lib/mstem-mock/smarthome-dashboard';

import SmartHomeDashboardModalComponent from '../components/smarthome-dashboard-modal/smarthome-dashboard-modal.jsx';

const MAX_POINTS = 20;
const TICK_MS = 2000;

class SmartHomeDashboardModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleTick', 'handleClose']);
        this.state = {
            series: getInitialSeries(),
            rfidLogs: getRfidLogs(),
            alerts: getAlerts()
        };
        this._intervalId = null;
    }
    componentDidMount () {
        this._intervalId = setInterval(this.handleTick, TICK_MS);
    }
    componentWillUnmount () {
        if (this._intervalId !== null) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }
    }
    handleTick () {
        this.setState(prev => ({
            series: prev.series.concat(nextPoint(prev.series)).slice(-MAX_POINTS)
        }));
    }
    handleClose () {
        this.props.onRequestClose();
    }
    render () {
        const {series, rfidLogs, alerts} = this.state;
        const latest = series[series.length - 1];
        return (
            <SmartHomeDashboardModalComponent
                series={series}
                latest={latest}
                rfidLogs={rfidLogs}
                alerts={alerts}
                onRequestClose={this.handleClose}
            />
        );
    }
}

SmartHomeDashboardModal.propTypes = {
    onRequestClose: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
    onRequestClose: () => dispatch(closeSmartHomeDashboard())
});

export default connect(
    null,
    mapDispatchToProps
)(SmartHomeDashboardModal);
